import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('toast', {
  root: { states: ['mobile'] },
  content: {},
  dismiss: {},
  dismissButton: {},
});
